export function hasFeature(permission) {
    const permissions = localStorage.getItem('features');
    if (!permissions) {
        return false;
    }
    const storedPermissions = JSON.parse(permissions)
    return storedPermissions.map(x => x.name).includes(permission) && storedPermissions.some(x => x.name === permission && x.enabled)
}
